<template>
<div class="content background-slider has-text-centered">
</div>
</template>
<style lang="scss" scoped>
/* Working method */
.background-slider
{
  height:100vh;
  
  background:
  linear-gradient(
      rgba(250, 83, 83, 0.481), 
      rgba(107, 22, 22, 0.492)
    ),
  url(~assets/img_12.jpg),
  center no-repeat;
  background-size: cover;
}
</style>
<script>

export default{
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// background_slider.vue?1a039aa2